import { render, staticRenderFns } from "./ztProgressBar.vue?vue&type=template&id=1889d3c4&scoped=true&"
import script from "./ztProgressBar.vue?vue&type=script&lang=js&"
export * from "./ztProgressBar.vue?vue&type=script&lang=js&"
import style0 from "../../../../styles/components/ztProgressBar.css?vue&type=style&index=0&id=1889d3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889d3c4",
  null
  
)

export default component.exports